import { useQuery } from '@tanstack/react-query'

import { ApiUrlPath, X_AUTH_TOKEN, IQuestion, AppMsg } from 'cat-shared/utils'
import { fetch, getAbortController, getLocalAuthUser } from 'client/services'

export type TGetProposedQuestionsData = {
  count: number
  data: IQuestion[]
}

type TError = {
  msg: AppMsg
}

export const useGetProposedQuestions = () => {
  const getProposedQuestions = async () => {
    const token = getLocalAuthUser().token

    const abortController = getAbortController(25)

    const res = await fetch(ApiUrlPath.GetProposedQuestions, {
      headers: { 'Content-Type': 'application/json', [X_AUTH_TOKEN]: token || '' },
      signal: abortController.signal,
    })

    abortController.clear()

    if (res.ok) {
      const body = (await res.json()) as TGetProposedQuestionsData
      body.data.sort((a, b) => a.createdAt - b.createdAt)
      return Promise.resolve(body)
    } else {
      const err = (await res.json()) as TError
      return Promise.reject(err)
    }
  }

  return useQuery<TGetProposedQuestionsData, TError>(
    [ApiUrlPath.GetProposedQuestions],
    getProposedQuestions,
    {
      enabled: false,
      keepPreviousData: true,
      cacheTime: 0,
    }
  )
}
